import { Component, type ErrorInfo, type ReactNode } from 'react';

export class ErrorFallback extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error: Error, info: ErrorInfo) { console.error('Smackers presentation error', error, info); }
  render() {
    if (this.state.failed) return <main className="fatal-error"><h1>THE CABINET ATE A QUARTER</h1><p>Reload the page to restart attract mode.</p></main>;
    return this.props.children;
  }
}
